import { ICONS } from "../../utils/iconUtil";

const Icon = ({
  name,
  className = "",
  cursorPointer = true,
  notAllowed = false,
  onClick,
  size = "15",
  disabled = false,
  title = "",
  ...props
}) => {
  // Dynamically choose the icon based on the name
  const IconComponent = ICONS[name];

  if (!IconComponent) return null;

  return (
    <IconComponent
      className={className}
      style={{
        cursor: cursorPointer ? "pointer" : notAllowed ? "not-allowed" : "",
      }}
      size={size}
      onClick={onClick}
      disabled={disabled}
      title={title}
      {...props}
    />
  );
};

export default Icon;
